var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from '@ember-data/model';
import { computed } from '@ember/object';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
import { isEmpty } from '@ember/utils';
let ComboSlot = (_dec = attr('string'), _dec2 = attr('number', {
  defaultValue: 1
}), _dec3 = belongsTo('item-variation', {
  async: false,
  inverse: null
}), _dec4 = belongsTo('item', {
  async: false,
  inverse: null
}), _dec5 = belongsTo('category', {
  async: false,
  inverse: null
}), _dec6 = computed('isNew', 'name', 'item', 'menuCategory', {
  get() {
    return !this.isNew || !isEmpty(this.item) || !isEmpty(this.menuCategory) || !isEmpty(this.name);
  }
}), _dec7 = attr('boolean', {
  defaultValue: false
}), _class = (_class2 = class ComboSlot extends ItemsV3Base {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    // The number of selections in order to fulfill this slot
    _initializerDefineProperty(this, "numSelections", _descriptor2, this);
    // (Optional) Default item variation of this slot
    _initializerDefineProperty(this, "defaultItemVariation", _descriptor3, this);
    // The item for this slot. Any variation of the item can fulfill this slot.
    _initializerDefineProperty(this, "item", _descriptor4, this);
    // The category for this slot. Any item variation in this category (or a sub-category)
    // can fulfill this slot.
    _initializerDefineProperty(this, "menuCategory", _descriptor5, this);
    _initializerDefineProperty(this, "hasBeenConfigured", _descriptor6, this);
    _initializerDefineProperty(this, "hasReordered", _descriptor7, this);
  }
  static catalogType() {
    return 'COMBO_SLOT';
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'combo-slot'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "numSelections", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "defaultItemVariation", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "item", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "menuCategory", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasBeenConfigured", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hasReordered", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ComboSlot as default };